import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <polygon points="13.8,11.2 20.1,11.2 18.2,9.3 20,7.5 25,12.5 20,17.5 18.2,15.7 20.1,13.8 13.8,13.8 13.8,20.1 15.7,18.2 17.5,20 12.5,25 7.5,20 9.3,18.2 11.2,20.1 11.2,13.8 4.9,13.8 6.8,15.7 5,17.5 0,12.5 5,7.5 6.8,9.3 4.9,11.2 11.2,11.2 11.2,4.9 9.3,6.8 7.5,5 12.5,0 17.5,5 15.7,6.8 13.8,4.9 " />
    </g>
  </svg>
);
